import ClassNames from 'classnames'
import React from 'react'
import {
  WarrantySignatureWrapper
} from './styled'


export class WarrantyBSWMThailandSignature extends React.PureComponent {
  render() {

    // props for css classes
    const classes = ClassNames(
      'warranty-bswm-signature',
    )

    return (
      <WarrantySignatureWrapper
        className={classes}
      >
      </WarrantySignatureWrapper>
    )
  }

  static defaultProps = {
    // If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
